import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import "./../../../components/UserRegistration/AddUser.css";
import {
  Card,
  Row,
  Col,
  Spin,
  Button,
  Select,
  Input,
  Table,
  Radio,
  DatePicker,
  notification,
} from "antd";
import { Form } from '@ant-design/compatible';
import Config from "./../../../config";
import { updateUserList } from "./../../../store/broadcaster/BroadcastRegister";
import { CloseCircleFilled } from "@ant-design/icons";
import MirraLogo from "./../../images/new_mirra_logo.png";
import cshLogo from './../../images/ReportLogos/cshLogo.png';
import Postdata from "./../../Pages/Postdata";
import axios from "axios";
import "./Registration.css";
import ProviderTaxid from "../../UserRegistration/ProviderTaxid";
import GroupAdmin from "../../UserRegistration/GroupAdmin";

class AddUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDsnp: "",
      componentKey: 1,
      npiValidated: false,
      taxIdValidated: false,
      ipaNameValidated: false,
      AddedNPI: null,
      AddedTaxId: null,
      AddedIPAName: null,
      RedirectOnCancel: false,
      disableNPIAdd: true,
      // AddedNPIs: [],
      isLoading: false,
      addTax: false,
      addNpi: false,
      addIPAName: false,
      combinations: [],
      SelectValue: "",
      Geticon: false,
      clicked: false,
      Taxclicked: false,
      FieldType: false,
      ProviderNPIs: [],
      ProviderTaxIDs: [],
      TaxID: [],
      AddRole: [],
      message: "",
      disabledNPI: false,
      disabled: false,
      inputvalue: "",
      disableRole: "",
      UserType: "",
      RoleWithOptions: "",
      RoleWiththreeOption: "",
      RoleWithFourOption: "",
      deleteTaxNpiMapping: [],

      FirstName: "",
      MiddleName: "",
      LastName: "",
      JobTitle: "",
      ProviderName: "",
      PhoneNumber: "",
      FaxID: "",
      EMail: "",
      ZipCode: "",
      Country: "",
      State: "",
      City: "",
      Address1: "",
      Address2: "",
      npiList: [],
      tenantId: null,
      providedselectedValues:null,
      NPI:[],
      TaxNpiMapping:[],

    };
  }

  componentDidMount() {
    if (sessionStorage.getItem("Tanent")) {
      this.setState({ tenantId: sessionStorage.getItem("Tanent") });
    } else this.getTanentId();
  }

  getTanentId = () => {
   // console.log("2222")
    const { setLoading } = this.props; // Access setLoading from props
    console.log("getTenantId called"); // Debug log
    if (!setLoading) {
      console.error("setLoading is undefined");
      return;
    }else{
      console.error("setLoading is defined");
    }
     // Start the loader
     setLoading(false);
    fetch(
      `${Config.api}/GetTenantIDByName?TenantName=${sessionStorage.getItem(
        "planName"
      )}`
    )
      .then((response) => response.json())
      .then((res) => {
        console.log(res);
        this.setState({
          tenantId: res.TenantID ? res.TenantID : null,
        });
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching tenant ID:", error);

        // Stop loader on error
        setLoading(false);
      });
  };


  setCombinations = (items) => {
    console.log("items-1",items)
    this.setState({
      combinations: items && items.length > 0 ? items : [],
    });
  };
  
  setProviderCombinations = (items)=>{
    console.log("items-2",items)
    const result = {
      Provider_NPI_TAXID: items.flatMap(item =>
        item.npis.map(npiObj => ({
          TaxID: item.taxId,
          NPI: npiObj.npi.toString()   // convert to string if needed
        }))
      )
    };
    this.setState({
      providedselectedValues:result,
      ProviderNPIs: items && items.length > 0 ? items[0].npis : [],
      TaxID: items && items.length > 0 ? items[0].taxId : "", 
    });
  }

  handleName = (e) => {
    return null;
  };

  handleCancel = () => {
    this.setState({ RedirectOnCancel: true });
  };

  handleChange = (e, type) => {
    let regex = new RegExp(/^[0-9]*$/);
    if (regex.test(e.target.value)) {
      this.setState({
        npiValidated:
          type === "NPI"
            ? e.target.value.length === 10
            : this.state.npiValidated,
        taxIdValidated:
          type === "TaxID"
            ? e.target.value.length === 9
            : this.state.taxIdValidated,
        ipaNameValidated: 
          type == "IPAName" 
            ? e.target.value !== ""
            : this.state.ipaNameValidated,
        FieldType: type,
      });
    }
    if(type == "IPAName" ){
      this.setState({
        ipaNameValidated: 
          type == "IPAName" 
            ? e.target.value !== ""
            : this.state.ipaNameValidated,
        FieldType: type,
      });
    }
  };

  openNotification = (res) => {
    notification.open({
      description:
        res.Message === "" ? "Email ID already Exist !" : res.Message,
      // onClick: () => {
      // },
    });
  };
  setDeletedCombinations = (item) => {
    this.setState({
      deleteTaxNpiMapping: item
        ? [...this.state.deleteTaxNpiMapping, item]
        : [...this.state.deleteTaxNpiMapping],
    });
  };

  addItem = (e, type) => {
    e.preventDefault();
    // this.state.AddedNPIs.push({NPI: newItem})
    this.setState({
      // AddedNPIs: this.state.AddedNPIs,
      AddedNPI: type === "NPI" ? this.NPIRef.value : this.state.AddedNPI,
      AddedTaxId: type === "TaxID" ? this.TaxRef.value : this.state.AddedTaxId,
      AddedIPAName: type === "IPAName" ? this.IPAName.value : this.state.IPAName
    });
  };

  removeItem = async (type) => {
    this.setState({
      npiValidated: type === "NPI" ? false : this.state.npiValidated,
      taxIdValidated: type === "TaxID" ? false : this.state.taxIdValidated,
      ipaNameValidated: type === "IPAName" ? false : this.state.ipaNameValidated,
      AddedTaxId: type === "TaxID" ? null : this.state.AddedTaxId,
      AddedNPI: type === "NPI" ? null : this.state.AddedNPI,
      AddedIPAName: type === "IPAName" ? null : this.state.AddedIPAName
    });
  };

  validateRolesAndValues = () => {
    let mapping = [];
    let NPI
    if (this.state.RoleWithOptions === "Group User") {
      //return this.state.AddedTaxId && this.state.AddedNPI ? true : false;
      let taxCombination = this.state.combinations.filter(
        (item) => item.taxId != "None"
      );
      if (taxCombination && taxCombination.length > 0) {
        for (let item of taxCombination) {
          let _npis = [];
          if (!item.delete && !item.save) {
            //when item (taxID) is new
            mapping.push({ TaxID: item.taxId, NPIList: _npis });
            for (let npi of item.npis) {
              if (!npi.delete && !npi.save)
                _npis.push({ NPINumber: npi.npi });
              // if (!npi.delete && !npi.save && npi.GroupNPI)
              //   _npis.push({ NPINumber: npi.GroupNPI });
            }
          }
        }
      }
      console.log("mapping",mapping)
      // this.setState({
      //   TaxNpiMapping:mapping
      // })
      let npiCombination = this.state.combinations.filter(
        (item) => item.taxId === "None"
      )[0];
      if (npiCombination) {
          NPI = npiCombination.npis.map((item) => {
          return { NPINumber: item.npi };
        });
      }
       console.log("NPI",NPI)
       this.setState({
        NPI:NPI,
        TaxNpiMapping:mapping
      })

      return true
  
    } else if (this.state.RoleWithOptions === "IPA User") {
      return this.state.AddedIPAName ? true : false;
  
    } else if (this.state.RoleWithOptions === "Provider") {
      
      return this.state.ProviderNPIs ? true : false;
      
  
    } else {
      return false;
    }
  };
  

  handleRequestAccess = (e) => {
    e.preventDefault();
    // if(err)//
    this.props.form.validateFields(async (err, values) => {
      if (!err && this.validateRolesAndValues()) {
         let selectedValues
        if(this.state.RoleWithOptions !=="Provider"){
          const output = this.state.combinations.flatMap(item => {
            const taxId = (item.taxId && item.taxId !== "None") ? item.taxId : "";
          
            return item.npis.map(npiObj => ({
              TaxID: taxId,
              NPI: String(npiObj.npi) // ensure string format
            }));
          });
          
          console.log(output);
         selectedValues = output;
      } else{
        selectedValues= this.state.providedselectedValues.Provider_NPI_TAXID

      }
      console.log("/////////////////")
      console.log(this.state.TaxNpiMapping)
      console.log(this.state.NPI)
        var formData = {
          FirstName: values.FirstName,
          MiddleName: values.MiddleName,
          LastName: values.LastName,
          JobTitle: values.JobTitle,
          ProviderName: values.ProviderName,
          ContactNumber: values.PhoneNumber,
          FaxNumber: values.FaxID,
          EmailID: values.EMail,
          ZipCode: values.ZipCode,
          Country: values.Country,
          State: values.State,
          City: values.City,
          Address01: values.Address1,
          Address02: values.Address2,
          AccessLevel: this.state.RoleWithOptions,
          Provider_NPI_TAXID: selectedValues,
          IPAName: this.state.AddedIPAName,
          TenantId: this.state.tenantId,
          IsDSNP: this.state.isDsnp,
          PlanName: sessionStorage.getItem("planName"),
          NPI:this.state.NPI,
          TaxNpiMapping:this.state.TaxNpiMapping,
          URL: `https://${window.location.host}`,
        };
        console.log("payload",formData)
        console.log(this.state.combinations)
        this.setState({ isLoading: true });
        axios
          .post(Config.Providermgmt + "/RegisterProvider", formData)
          .then((res) => {
            this.openNotification1(res.data);
            this.setState({ RedirectOnCancel: true });
          })
          .catch((err) => {
            if (err.message === "Request failed with status code 400") {
              this.openNotification1({
                Message: err.response.data.Message,
              });
              this.setState({ RedirectOnCancel: true });
            } else {
              this.openNotification1({
                Message: err.response.data.Message
              });
              this.setState({ RedirectOnCancel: true });
            }
          })
          .finally(() => {
            this.setState({ isLoading: false });
          });
      }
    });
  };

  openNotification1 = (res) => {
    notification.open({
      description: res.Message,
    });
  };

  getTitleOnRole = () => {
    let title =
      this.state.SelectValue === "Provider"
        ? "Provider"
        : this.state.SelectValue === "Group User"
          ? "Group"
          : "IPA";
    return title;
  };

  handleReset = () => {
    this.props.getType("List");
    this.setState({
      SelectValue: "",
      CurrentAge: "",
      AddRole: [],
      Geticon: false,
      clicked: false,
    });
  };
  getValue = () => {
    this.setState({
      Geticon: true,
    });
  };

  onChange = (e) => {
    this.setState({
      UserType: e.target.value,
    });
  };
  ChangeDsnpOption = (e)  => {
    
    this.setState({
      isDsnp: e.target.value,
    })
  }

  ChangeWithOptions = (e) => {
    this.setState({
      componentKey: this.state.componentKey + 1,
      FieldType: null,
      AddedNPI: null,
      AddedTaxId: null,
      npiValidated: false,
      taxIdValidated: false,
      RoleWithOptions: e.target.value,
      SelectValue: e.target.value,
      combinations:[],
      providedselectedValues:{},
      ProviderNPIs:[]
    });
  };

  render() {
    if (this.state.RedirectOnCancel) {
      return <Redirect to={"/login"} />;
    }
    const { Option } = Select;
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: {
        xs: { span: 5 },
        sm: { span: 10 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
      },
    };
    return (
      <div>
        <div class="square-blue-profile">
          <Row
            className="ml-4"
            type="flex"
            justify-content="space-start"
            align="middle"
            style={{ padding: "10px" }}
          >
            <Col>
              <div
                style={{
                  color: "white",
                  fontSize: "18px",
                  fontWeight: "bold",
                }}
              >
                User Registration
              </div>
            </Col>
            <Col push={19}>
              <div className="mirralogo">
                <img
                  src={sessionStorage.getItem("planName") === "csh" ? cshLogo : MirraLogo}
                  alt="Mirra Logo"
                  width="90"
                  height="97"
                  className={
                    sessionStorage.getItem("planName") === "csh"
                      ? "cshlogo-img"
                      : "mirralogo-img"
                  }
                />
              </div>
            </Col>
            {/* <Col push={18} className="ml-4"></Col> */}
          </Row>
        </div>
        <Form
          {...formItemLayout}
        // onSubmit={this.handleSubmit}
        >
          <div className="flex-container">
            {/* Personal Information */}
            <div className="flex-child">
              <div
                className="square-white-adduser-personalInformation ml-5 mb-5 mt-5"
                style={{ maxHeight: "300px", minHeight: "300px" }}
              >
                <div className="PersonalInformation">
                  01. Enter Basic Information
                </div>
                <br />
                <Row style={{ height: "85px" }}>
                  <Col span={6} push={1}>
                    <div
                      className="form-text-decorator ml-1 mt-2"
                      style={{ fontWeight: "600", fontSize: "12px" }}
                    >
                      Your First Name
                      <span style={{ color: "red" }}>*</span>
                    </div>
                    <Form.Item>
                      {getFieldDecorator("FirstName", {
                        initialValue: this.state.FirstName,
                        // value: this.state.FirstName,
                        rules: [
                          {
                            required: true,
                            message: (
                              <span style={{ fontSize: "12px" }}>
                                This field is mandatory
                                <br />
                              </span>
                            ),
                          },
                          {
                            pattern: new RegExp(/^[ A-Za-z0-9!#$%&'*+-/=?^_`{|]*$/),
                            message: (
                              <span style={{ fontSize: "12px" }}>
                                No special characters
                                <br />
                              </span>
                            ),
                          },
                          {
                            max: 64,

                            message: (
                              <span style={{ fontSize: "12px" }}>
                                Can't exceed 64 characters
                                <br />
                              </span>
                            ),
                          },
                        ],
                      })(
                        <Input
                          size="lg"
                          placeholder="Enter"
                          onChange={this.handleName}
                          value={this.state.FirstName}
                          maxLength="65"
                        />
                      )}
                    </Form.Item>
                  </Col>

                  <Col span={6} push={1} hidden>
                    <div
                      className="form-text-decorator ml-1 mt-2"
                      style={{ fontWeight: "600", fontSize: "12px" }}
                    >
                      Id
                      <span style={{ color: "red" }}>*</span>
                    </div>
                    <Form.Item>
                      {getFieldDecorator("Id", {
                        initialValue: sessionStorage.getItem("UserID"),
                        rules: [
                          {
                            required: false,
                            message: "   ",
                          },
                        ],
                      })(
                        <Input size="lg" placeholder="Enter" maxLength="24" />
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={6} push={1} hidden>
                    <div
                      className="form-text-decorator ml-1 mt-2"
                      style={{ fontWeight: "600", fontSize: "12px" }}
                    >
                      Tanent ID
                    </div>
                    <Form.Item>
                      {getFieldDecorator("TenantID", {
                        initialValue: "",
                        rules: [
                          {
                            required: false,
                            message: "   ",
                          },
                        ],
                      })(
                        <Input size="lg" placeholder="Enter" maxLength="24" />
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={6} push={1} hidden>
                    <div
                      className="form-text-decorator ml-1 mt-2"
                      style={{ fontWeight: "600", fontSize: "12px" }}
                    >
                      Tanent ID
                    </div>
                    <Form.Item>
                      {getFieldDecorator("URL", {
                        initialValue: sessionStorage.getItem("url"),
                        rules: [
                          {
                            required: false,
                            message: "   ",
                          },
                        ],
                      })(
                        <Input size="lg" placeholder="Enter" maxLength="24" />
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={6} push={1}>
                    <div
                      className="form-text-decorator ml-1 mt-2"
                      style={{ fontWeight: "600", fontSize: "12px" }}
                    >
                      Your Middle Name
                    </div>
                    <Form.Item>
                      {getFieldDecorator("MiddleName", {
                        initialValue: this.state.MiddleName,
                        rules: [
                          {
                            pattern: new RegExp(/^[ A-Za-z0-9!#$%&'*+-/=?^_`{|]*$/),
                            message: (
                              <span style={{ fontSize: "12px" }}>
                                No special characters
                                <br />
                              </span>
                            ),
                          },
                          {
                            max: 64,

                            message: (
                              <span style={{ fontSize: "12px" }}>
                                Can't exceed 64 characters
                                <br />
                              </span>
                            ),
                          },
                        ],
                      })(
                        <Input size="lg" placeholder="Enter" maxLength="65" />
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={6} push={1}>
                    <div
                      className="form-text-decorator ml-1 mt-2"
                      style={{ fontWeight: "600", fontSize: "12px" }}
                    >
                      Your Last Name
                      <span style={{ color: "red" }}>*</span>
                    </div>
                    <Form.Item>
                      {getFieldDecorator("LastName", {
                        initialValue: this.state.LastName,
                        rules: [
                          {
                            required: true,
                            message: (
                              <span style={{ fontSize: "12px" }}>
                                This field is mandatory
                                <br />
                              </span>
                            ),
                          },
                          {
                            pattern: new RegExp(/^[ A-Za-z0-9!#$%&'*+-/=?^_`{|]*$/),
                            message: (
                              <span style={{ fontSize: "12px" }}>
                                No special characters
                                <br />
                              </span>
                            ),
                          },
                          {
                            max: 64,
                            message: (
                              <span style={{ fontSize: "12px" }}>
                                Can't exceed 64 characters
                                <br />
                              </span>
                            ),
                          },
                        ],
                      })(
                        <Input size="lg" placeholder="Enter" maxLength="65" />
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={6} push={1}>
                    <div
                      className="form-text-decorator ml-1 mt-2"
                      style={{ fontWeight: "600", fontSize: "12px" }}
                    >
                      Your Job Title
                      <span style={{ color: "red" }}>*</span>
                    </div>
                    <Form.Item>
                      {getFieldDecorator("JobTitle", {
                        initialValue: this.state.JobTitle,
                        rules: [
                          {
                            required: true,
                            message: (
                              <span style={{ fontSize: "12px" }}>
                                This field is mandatory
                                <br />
                              </span>
                            ),
                          },
                          {
                            pattern: new RegExp("^[a-zA-Z' ']*$"),
                            message: (
                              <span style={{ fontSize: "12px" }}>
                                Enter alphabets only!
                                <br />
                              </span>
                            ),
                          },
                          {
                            max: 100,
                            message: (
                              <span style={{ fontSize: "12px" }}>
                                Can't exceed 100 characters
                                <br />
                              </span>
                            ),
                          },
                        ],
                      })(
                        <Input size="lg" placeholder="Enter" maxLength="101" />
                      )}
                    </Form.Item>
                  </Col>
                </Row>
                <br />
                <br />
                <Row>
                  <Col span={14} push={1}>
                    <div
                      className="form-text-decorator ml-1 mt-2"
                      style={{ fontWeight: "600", fontSize: "12px" }}
                    >
                      Provider/Group/IPA/Facility name
                      <span style={{ color: "red" }}>*</span>
                    </div>
                    <Form.Item>
                      {getFieldDecorator("ProviderName", {
                        initialValue: this.state.ProviderName,
                        rules: [
                          {
                            required: true,
                            message: (
                              <span style={{ fontSize: "12px" }}>
                                This field is mandatory
                                <br />
                              </span>
                            ),
                          },
                          {
                            pattern: new RegExp("^[a-zA-Z' ']*$"),
                            message: (
                              <span style={{ fontSize: "12px" }}>
                                Enter alphabets only
                                <br />
                              </span>
                            ),
                          },
                          {
                            max: 100,
                            message: (
                              <span style={{ fontSize: "12px" }}>
                                Can't exceed 100 characters
                                <br />
                              </span>
                            ),
                          },
                        ],
                      })(
                        <Input size="lg" placeholder="Enter" maxLength="101" />
                      )}
                    </Form.Item>
                  </Col>
                </Row>
                <br />
              </div>
            </div>
            {/* Contact Information */}
            <div className="flex-child">
              <div
                className="square-white-adduser-EnterContactInformation ml-2 mb-5 mt-5"
                style={{ maxHeight: "300px", minHeight: "300px" }}
              >
                <div className="ContactInformation ">
                  02. Enter Your Contact information
                </div>
                <br />
                <Row style={{ height: "85px" }} className="ml-4 pl-2">
                  <Col span={12}>
                    <div
                      className="form-text-decorator ml-1 mt-2"
                      style={{ fontWeight: "600", fontSize: "12px" }}
                    >
                      Contact No.
                    </div>
                    <Form.Item>
                      {getFieldDecorator("PhoneNumber", {
                        initialValue: this.state.PhoneNumber,
                        rules: [
                          {
                            required: false,
                            message: "   ",
                          },
                          {
                            pattern: new RegExp("^[0-9]*$"),
                            message: (
                              <span style={{ fontSize: "12px" }}>
                                Enter numbers only!
                                <br />
                              </span>
                            ),
                          },
                          {
                            max: 10,
                            message: (
                              <span style={{ fontSize: "12px" }}>
                                Can't exceed 10 digits
                                <br />
                              </span>
                            ),
                          },
                        ],
                      })(
                        <Input
                          size="lg"
                          placeholder="Enter"
                          maxLength="11"
                          pattern="[0-9\.]+"
                        // style={{ width: "130px" }}
                        />
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <div
                      className="form-text-decorator ml-1 mt-2"
                      style={{
                        fontWeight: "600",
                        fontSize: "12px",
                      }}
                    >
                      Fax No.
                    </div>
                    <Form.Item>
                      {getFieldDecorator("FaxID", {
                        initialValue: this.state.FaxID,
                        rules: [
                          {
                            required: false,
                            message: "   ",
                          },
                          {
                            pattern: new RegExp("^[0-9]*$"),
                            message: (
                              <span style={{ fontSize: "12px" }}>
                                Enter numbers only!
                                <br />
                              </span>
                            ),
                          },
                          {
                            max: 10,
                            message: (
                              <span style={{ fontSize: "12px" }}>
                                Can't exceed 10 digits
                                <br />
                              </span>
                            ),
                          },
                        ],
                      })(
                        <Input
                          size="lg"
                          placeholder="Enter"
                          maxLength="11"
                        // style={{ width: "130px" }}
                        />
                      )}
                    </Form.Item>
                  </Col>
                </Row>
                <br />
                <br />
                <Row className="ml-4 pl-2">
                  <Col span={24}>
                    <div
                      className="form-text-decorator ml-1 mt-2"
                      style={{ fontWeight: "600", fontSize: "12px" }}
                    >
                      Email ID
                      <span style={{ color: "red" }}>*</span>
                    </div>
                    <Form.Item>
                      {getFieldDecorator("EMail", {
                        initialValue: this.state.EMail,
                        rules: [
                          {
                            required: true,
                            message: (
                              <span style={{ fontSize: "12px" }}>
                                This field is mandatory
                                <br />
                              </span>
                            ),
                          },
                          {
                            // pattern: new RegExp(/^[A-Za-z][\w$.]+@[\w]+\.\w+$/), //oRIGINAL
                            pattern: new RegExp(/^[a-zA-Z0-9.!#$%&'*+\-/=?^_`{|]{1,64}@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63}$/),
                            message: (
                              <span style={{ fontSize: "12px", marginRight: "5px" }}>
                                Enter a valid email
                              </span>
                            ),
                          },
                          {
                            max: 250,
                            message: (
                              <span style={{ fontSize: "12px", marginRight: "5px" }}>
                                Email ID field allows 250 characters only
                              </span>
                            ),
                          },
                        ],
                      })(
                        <Input
                          size="lg"
                          placeholder="Enter"
                          maxLength="251"
                        // style={{ width: "312px" }}
                        />
                      )}
                    </Form.Item>
                  </Col>
                </Row>
                <br />
              </div>
            </div>
          </div>
          {/*Location Information*/}
          <div className="square-white-adduser-LocationInformation ml-5 mb-5">
            <div className="LocationInformation">
              03. Enter Your Office Location Information
            </div>
            <br />
            <Row className="pr-4">
              <Col span={4} className="pl-4">
                <div
                  className="form-text-decorator ml-1 mt-2"
                  style={{ fontWeight: "600", fontSize: "12px" }}
                >
                  Address 01
                  {/* <span style={{ color: "red" }}>*</span> */}
                </div>
                <Form.Item>
                  {getFieldDecorator("Address1", {
                    initialValue: this.state.Address1,
                    rules: [
                      {
                       // required: true,
                        message: (
                          <span style={{ fontSize: "12px" }}>
                            This field is mandatory
                            <br />
                          </span>
                        ),
                      },
                      {
                        pattern: new RegExp("^[a-zA-Z0-9' ']*$"),
                        message: (
                          <span style={{ fontSize: "12px" }}>
                            Special Characters not allowed!
                            <br />
                          </span>
                        ),
                      },
                      {
                        max: 150,
                        message: (
                          <span style={{ fontSize: "12px" }}>
                            Can't exceed 150 characters
                            <br />
                          </span>
                        ),
                      },
                    ],
                  })(
                    <Input
                      placeholder="Select"
                      style={{ width: "160px" }}
                      size="lg"
                      maxLength="151"
                    />
                  )}
                </Form.Item>
              </Col>
              <Col span={4} className="pl-4">
                <div
                  className="form-text-decorator ml-1 mt-2"
                  style={{ fontWeight: "600", fontSize: "12px" }}
                >
                  Address 02
                </div>
                <Form.Item>
                  {getFieldDecorator("Address2", {
                    initialValue: this.state.Address2,
                    rules: [
                      {
                        pattern: new RegExp("^[a-zA-Z1-9' ']*$"),
                        message: "Special Characters not allowed!",
                      },
                      {
                        required: false,
                        message: "   ",
                      },
                      {
                        max: 150,
                        message: (
                          <span style={{ fontSize: "12px" }}>
                            Can't exceed 150 characters
                            <br />
                          </span>
                        ),
                      },
                    ],
                  })(
                    <Input
                      placeholder="Select"
                      style={{ width: "160px" }}
                      size="lg"
                      maxLength="151"
                    />
                  )}
                </Form.Item>
              </Col>
              <Col span={4} className="pl-4">
                <div
                  className="form-text-decorator ml-1 mt-2"
                  style={{ fontWeight: "600", fontSize: "12px" }}
                >
                  City
                </div>
                <Form.Item>
                  {getFieldDecorator("City", {
                    initialValue: this.state.City,
                    rules: [
                      {
                        required: false,
                        message: "   ",
                      },
                      {
                        pattern: new RegExp("^[a-zA-Z' ']*$"),
                        message: "Enter alphabets only!",
                      },
                      {
                        max: 100,
                        message: (
                          <span style={{ fontSize: "12px" }}>
                            Can't exceed 100 digits
                            <br />
                          </span>
                        ),
                      },
                    ],
                  })(
                    <Input
                      placeholder="Select"
                      style={{ width: "160px" }}
                      size="lg"
                      maxLength="101"
                    />
                  )}
                </Form.Item>
              </Col>
              <Col span={4} className="pl-4">
                <div
                  className="form-text-decorator ml-1 mt-2"
                  style={{ fontWeight: "600", fontSize: "12px" }}
                >
                  State
                </div>
                <Form.Item>
                  {getFieldDecorator("State", {
                    initialValue: this.state.State,
                    rules: [
                      {
                        required: false,
                        message: "   ",
                      },
                      {
                        pattern: new RegExp("^[a-zA-Z' ']*$"),
                        message: "Enter alphabets only!",
                      },
                      {
                        max: 100,
                        message: (
                          <span style={{ fontSize: "12px" }}>
                            Can't exceed 100 characters
                            <br />
                          </span>
                        ),
                      },
                    ],
                  })(
                    <Input
                      size="lg"
                      placeholder="Enter"
                      style={{ width: "160px" }}
                      maxLength="101"
                    />
                  )}
                </Form.Item>
              </Col>
              <Col span={4} className="pl-4">
                <div
                  className="form-text-decorator ml-1 mt-2"
                  style={{ fontWeight: "600", fontSize: "12px" }}
                >
                  Country
                </div>
                <Form.Item>
                  {getFieldDecorator("Country", {
                    initialValue: this.state.Country,
                    rules: [
                      {
                        required: false,
                        message: "   ",
                      },
                      {
                        pattern: new RegExp("^[a-zA-Z' ']*$"),
                        message: "Enter Alphabets Only!",
                      },
                      {
                        max: 100,
                        message: (
                          <span style={{ fontSize: "12px" }}>
                            Can't exceed 100 characters
                            <br />
                          </span>
                        ),
                      },
                    ],
                  })(
                    <Input
                      size="lg"
                      placeholder="Enter"
                      style={{ width: "160px" }}
                      maxLength="101"
                    />
                  )}
                </Form.Item>
              </Col>
              <Col span={4} className="pl-4">
                <div
                  className="form-text-decorator ml-1 mt-2"
                  style={{ fontWeight: "600", fontSize: "12px" }}
                >
                  Zipcode
                  {/* <span style={{ color: "red" }}>*</span> */}
                </div>
                <Form.Item>
                  {getFieldDecorator("ZipCode", {
                    initialValue: this.state.ZipCode,
                    rules: [
                      {
                      //  required: true,
                        message: (
                          <span style={{ fontSize: "12px" }}>
                            This field is mandatory
                            <br />
                          </span>
                        ),
                      },
                      {
                        pattern: new RegExp("^[0-9]*$"),
                        message: (
                          <span style={{ fontSize: "12px" }}>
                            Enter numbers only!
                            <br />
                          </span>
                        ),
                      },
                      {
                        max: 5,
                        message: (
                          <span style={{ fontSize: "12px" }}>
                            Can't exceed 5 digits
                            <br />
                          </span>
                        ),
                      },
                    ],
                  })(
                    <Input
                      size="lg"
                      placeholder="Enter"
                      style={{ width: "160px" }}
                      maxLength="6"
                    />
                  )}
                </Form.Item>
              </Col>
            </Row>
            <br />
            <br />
          </div>

          <div className="square-white-adduser-LocationInformation ml-5 mb-5">
            <div className="p-2 PersonalInformation mb-4 ml-3">
              04. Assign Role
            </div>
            <div className="p-2 ml-3 mr-3">
              <div className="pb-3">
                {true && (
                  <>
                  <Card className="card-css pl-2 pt-1 pb-1">
                    <Row>
                      <Col span={16} className="question-css">
                        <b>Which Level of access are you requesting?</b>
                        <span style={{ color: "#D14A4A" }}>*</span>
                      </Col>
                      <Col span={8} style={{ textAlign: "right" }}>
                        <Radio.Group
                          onChange={(e) => this.ChangeWithOptions(e)}
                          value={this.state.RoleWithOptions}
                        >
                          <Radio value={"Group User"} className="question-css">
                            Group User
                          </Radio>

                          {sessionStorage.getItem("planName") !== "secur" && (
                            <Radio value={"IPA User"} className="question-css">
                              IPA User

                            </Radio>
                          )}
                          <Radio
                            value={"Provider"}
                            className="question-css"
                          >
                            Provider
                          </Radio>
                        </Radio.Group>
                      </Col>
                    </Row>
                  </Card>
                  </>
                )}

                {this.state.SelectValue && (
                  <Row
                    className="mt-3"
                    justify="space-between"
                    type="flex"
                    key={this.state.componentKey}
                  >
                    {
                      this.state.SelectValue === "IPA User" ? 
                      (
                      <Col span={24}>
                        <div className="mt-2">
                          <Row>
                            <Col span={24} className="ProviderNPI">
                              {this.state.AddedIPAName
                                ? "Added"
                                : "Add"}{" "}
                              {this.getTitleOnRole()} Name{" "}
                              <span style={{ color: "#D14A4A" }}>*</span>
                            </Col>
                            {!this.state.AddedIPAName && (
                              <Col span={12}>
                                <form
                                  ref={(input) => (this.addForm1 = input)}
                                  className="form-inline"
                                >
                                  <div className="form-group">
                                    <input
                                      required
                                      ref={(input) => (this.IPAName = input)}
                                      // onkeypress={this.isNumber}
                                      type="text"
                                      onKeyUp={(e) =>
                                        this.handleChange(e, "IPAName")
                                      }
                                      placeholder={`Enter`}
                                      className="form-control"
                                      id="newItemInput"
                                      style={{
                                        height: "34px",
                                        width: "380px",
                                        marginRight: "10px",
                                        backgroundColor: "#F8FBFF",
                                      }}
                                    ></input>
                                  </div>
  
                                  <button
                                    disabled={!this.state.ipaNameValidated}
                                    onClick={(e) => {
                                      this.addItem(e, "IPAName");
                                    }}
                                    type="submit"
                                    className="btn btn-primaryy butto-alluser px-3 py-1"
                                    style={{ background: "#427bdd" }}
                                  >
                                    Add
                                  </button>
                                  <span
                                    style={{ color: "red", fontSize: "12px" }}
                                  >
                                    {!this.state.ipaNameValidated
                                      ? // && this.state.FieldType === "TaxID"
                                      "*Please enter a valid IPA name"
                                      : ""}
                                  </span>
                                </form>
                              </Col>
                            )}
  
                            {this.state.AddedIPAName &&(
                                <Col span={12}>
                                  <div className="button pt-3">
                                    <span className="mr-3 pt-4 pb-2">
                                      {this.state.AddedIPAName}
                                    </span>
                                    <CloseCircleFilled
                                      className="pb-2"
                                      onClick={() => this.removeItem("IPAName")}
                                    />
                                    <br />
                                  </div>
                                </Col>
                              )}
                          </Row>
                        </div>
                      </Col>
                      ): null
                    }
                    {
                      this.state.SelectValue === "Group User" ? (
                        <Col span={24}>
                        <div className="p-2 group-admin-block">
                           
                          <GroupAdmin
                            List="Registration"
                            key={this.state.componentKey}
                            setCombinations={this.setCombinations}
                            getCombinations={this.state.combinations}
                            setDeletedCombinations={this.setDeletedCombinations}
                            selectrole="Group User"
                          />
                         
                        </div>
                        </Col>
                        
                      ) : null
                    }
                    {
                       this.state.SelectValue === "Provider" ? (
                        <>
                        
                        <Col span={24}>
                        <ProviderTaxid
                     List="Registration"
                     key={this.state.componentKey}
                     setProviderCombinations={this.setProviderCombinations}
                     getCombinations={this.state.ProviderNPIs}
                     setDeletedProviderCombinations={this.setDeletedProviderCombinations}
                     selectrole="Provider"
                     
                   />
                        </Col>
                        </>
                      ) : null}
                    
                  </Row>
                )}
                <br />

                {["solis", "ultimate", "csh", "PodAmerica"].includes(
                  (sessionStorage.getItem("planName") || "").toLowerCase()
                ) && (
                <Card className="card-css pl-2 pt-1 pb-1">
                  <Row>
                    <Col span={16} className="question-css">
                      <b>Should the user be able to access DSNP Member information?</b>
                    </Col>
                    <Col span={8} style={{ textAlign: "right" }}>
                      <Radio.Group
                        onChange={(e) => this.ChangeDsnpOption(e)}
                        value={this.state.isDsnp}
                      >

                        <Radio value={1} className="question-css">
                          Yes
                        </Radio>
                        <Radio value={0} className="question-css">
                          No
                        </Radio>
                      </Radio.Group>
                    </Col>
                  </Row>
                </Card>
                )}
                <br />
              </div>
            </div>
          </div>
          <div>
            <Row type="flex" justify="end" className="mx-5 pb-3">
              <Col>
                <button
                  className="cancle-button pl-4 pr-4 mr-3"
                  onClick={() => this.handleCancel()}
                >
                  Cancel
                </button>
                {/* {this.validateUser() && !this.state.isLoading && <button className="ml-3 butto-alluser pl-4 pr-4" onClick={() => { }}>Add User</button>}
                {this.state.isLoading && <span className="ml-2"><Spin size="small" /></span>} */}
              </Col>
              <Col>
                {/* <Button
                  // className="butto-alluser pl-4 pr-4"
                  htmlType="submit" className="save-button px-4 py-1 butto-alluser"
                  onClick={this.handleRequestAccess}
                  disabled={!this.state.RoleWithOptions || !(this.state.AddedTaxId && this.state.AddedNPI)}
                >
                  Request Access
                </Button> */}
                {!this.state.isLoading && (
                  <button
                    className="butto-alluser pl-4 pr-4"
                    onClick={this.handleRequestAccess}
                  >
                    Request Access
                  </button>
                )}
                {this.state.isLoading && (
                  <span className="ml-2">
                    <Spin size="small" />
                  </span>
                )}
              </Col>
            </Row>
          </div>
        </Form>
      </div>
    );
  }
}
export default Form.create({ name: "AddUser" })(AddUser);
